import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../components/grid";
import { getEmailHistory, documentDownload } from "../../../store/actions";
import { format } from "date-fns";
import BtnCellRenderer from "../../../components/grid/BtnCellRenderer";
class HistoryView extends Component {
  state = {
    loading: false,
    isSelectedRowData: "",
    isShow: false,
    isAddOrderShow: false,
    companyShortName: null,
    columnDefs: [
      {
        headerName: "Name ",
        field: "companyType",
        filter: false,
        width: 160,
        flex: 1,
      },
      {
        headerName: "Created",
        field: "createdAt",
        resizable: true,
        flex: 1,
        filter: false,

        valueFormatter: params => params.value ? format(new Date(params.value), 'P p') : ""
      },
      {
        headerName: "Report",
        field: "fileName",
        filter: false,
        flex: 1,
        cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          onClick: (params) => this.onClickDownloadDocument(params)
        },
      },
      {
        headerName: "Email Addresses",
        field: "clientLength",
        filter: false,
        flex: 1,
      },

    ],
    rowData: [],
    searchText: '',
  };
  emailPayload = {};

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    let dataSource = {
      getRows: async (params) => {

        this.emailPayload.startRow = params.startRow;
        this.emailPayload.endRow = params.endRow;
        this.emailPayload.searchText = this.state.searchText;
        this.emailPayload.sortColumn = params.sortModel.length ? params.sortModel[0]['colId'] : "reportName";
        this.emailPayload.sortType = params.sortModel.length ? params.sortModel[0]['sort'] : "asc";
        this.emailPayload.companyShortName = this.state.companyShortName;
        // use redux..
        this.gridApi.showLoadingOverlay();
        getEmailHistory(this.emailPayload).then(summeryReport => {

          this.gridApi.hideOverlay();
          if (!summeryReport.length) {
            this.gridApi.showNoRowsOverlay();
          } else {
            summeryReport.forEach(element => {
              if (element.sendToEmail.length) {
                element.clientLength = element.sendToEmail[0].emailMal
              } else {
                if (element.sendToEmail?.hasOwnProperty('client')) {
                  element.clientName = element.sendToEmail['client']
                  element.clientLength = element.sendToEmail?.sendTo
                }

              }
            });
            return params.successCallback(summeryReport, summeryReport.length);
          }
        });


      }
    }
    params.api.setDatasource(dataSource)
  }
  searchInput = (e) => {
    this.setState({ searchText: e.target.value });
    this.gridApi.purgeInfiniteCache();
  }
  refreshGrid = () => {
    this.gridApi.refreshInfiniteCache();
  }
  componentDidMount() {
    this.setState({ companyShortName: this.props.UserReducer.company })
  }

  async onClickDownloadDocument(event) {
    if (event.companyType === 'Admin') {
      let response = {};
      this.setState({ loading: true })
      let eventList = { ...event };
      let count = event.sendToEmail;
      for (let i = 0; i < count.length; i++) {
        eventList.sendToEmail = event.sendToEmail[i];
        response = await documentDownload(eventList);
        this.setState({ loading: false })
        if (event.fileFormat === 'pdf') {
          const url = window.URL.createObjectURL(
            new Blob([response], { type: "application/pdf" })
          );
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${event.reportName}.pdf`);
          document.body.appendChild(link);
          link.click();
        } else {
          const url = window.URL.createObjectURL(
            new Blob([response], { type: "application/*" })
          );
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${event.reportName}.csv`);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        }
      }
    } else {

      this.setState({ loading: true })
      let response = await documentDownload(event);
      this.setState({ loading: false })
      if (event.fileFormat === 'pdf') {
        const url = window.URL.createObjectURL(
          new Blob([response], { type: "application/pdf" })
        );
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${event.reportName}.pdf`);
        document.body.appendChild(link);
        link.click();
      } else {
        const url = window.URL.createObjectURL(
          new Blob([response], { type: "application/*" })
        );
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${event.reportName}.csv`);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
      }
    }
  }
  render() {
    return (
      <>
        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">
            <div className="filter-field d-flex">
              <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} /> {this.state.loading ? "Loading..." : null}
            </div>
          </div>
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              rowModelType='infinite'
              onGridReady={this.onGridReady}
              height='600px'
            >
            </Grid>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = ({ UserReducer }) => ({ UserReducer });
export default connect(mapStateToProps, {})(HistoryView);
